import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mapping } from '@weezevent/nacre';

const FormatterValues = ({ form, setFormObject, values, errors, disabled }) => {
    const { t } = useTranslation();

    const parseValues = React.useCallback(
        values => {
            return {
                ...form.definition,
                jmespath_values: values.reduce((acc, it) => {
                    acc[it.name] = it.value;
                    return acc;
                }, {})
            };
        },
        [form.definition]
    );

    const handleAdd = React.useCallback(() => {
        const newValues = [...values, { name: '', value: '', disabled }];
        setFormObject({ ...form, definition: parseValues(newValues) });
    }, [form, values, disabled]);

    const handleDelete = React.useCallback(
        key => {
            const newValues = [...values].filter(it => it.key !== key);
            setFormObject({ ...form, definition: parseValues(newValues) });
        },
        [form, values]
    );

    const handleChange = React.useCallback(
        (value, key, entry) => {
            const newValues = [...values].map(it => {
                if (it.key === key) {
                    it[entry] = value;
                }
                return it;
            });
            setFormObject({ ...form, definition: parseValues(newValues) });
        },
        [form, values]
    );

    return (
        <Mapping
            dynamic
            inputsOnly
            datas={values}
            errors={errors}
            onAddLine={handleAdd}
            onDeleteLine={handleDelete}
            disableCta={values.some(it => !it.name)}
            onChangeName={(value, key) => handleChange(value, key, 'name')}
            onChangeValue={(value, key) => handleChange(value, key, 'value')}
            cta_label={t('sauron.formatter.values.mapping_table.new_line_label')}
            first_header_label={t('sauron.formatter.values.mapping_table.row_name')}
            second_header_label={t('sauron.formatter.values.mapping_table.row_value')}
            name_placeholder={t('sauron.formatter.values.mapping_table.name_placeholder')}
            value_placeholder={t('sauron.formatter.values.mapping_table.value_placeholder')}
        />
    );
};

export default FormatterValues;
